// src/components/Container.js
import React from "react";
import "./ContainerXL.css";

/**
 * Container component that wraps its children with consistent styling.
 *
 * This component serves as a reusable wrapper that applies a consistent
 * style to its children, ensuring a uniform layout throughout the application.
 *
 * @component
 * @example
 * return (
 *   <Container>
 *     <Header />
 *     <MainContent />
 *     <Footer />
 *   </Container>
 * )
 */

const ContainerXL = ({ children, className }) => {
  return <section className={`containerXL  ${className}`}>{children}</section>;
};

export default ContainerXL;
